import { z } from 'zod';

/**
 * Partnerportal (ADR 0085) — die Sicht eines EXTERNEN Nutzers auf sich selbst.
 *
 * Bewusst NICHT `CurrentUserResponse`: Das interne DTO trägt Rollen, effektive
 * Berechtigungen, Navigations-Präferenzen und das Dashboard-Layout. Nichts
 * davon gehört nach außen — ein Partner soll weder unsere Rollennamen noch
 * unseren Rechte-Zuschnitt kennen. Was er braucht, ist: wer bin ich, für wen
 * stehe ich, und welche Sichten sind für mich freigeschaltet.
 */
export const portalCurrentUserSchema = z.object({
  id: z.string().uuid(),
  email: z.string(),
  name: z.string().nullable(),
  /** Der Partner, für den dieser Zugang steht (Firma). */
  partnerAccountId: z.string().uuid(),
  partnerName: z.string(),
  /** Welche Sichten das Portal für diesen Zugang zeigen darf. */
  canSeeForecast: z.boolean(),
  canSeeAssembly: z.boolean(),
  /** Für die Selbstverwaltung des zweiten Faktors (ADR 0034). */
  isTotpEnabled: z.boolean(),
  /**
   * Solange `true`, muss der Partner erst ein eigenes Passwort setzen (ADR 0085).
   * Das Anfangspasswort hat eine Administratorin vergeben und per Telefon oder
   * Mail übermittelt — es darf nicht das Dauerpasswort bleiben.
   */
  mustChangePassword: z.boolean(),
});

export type PortalCurrentUser = z.infer<typeof portalCurrentUserSchema>;
